import { render, staticRenderFns } from "./proceed-abandoned-case.vue?vue&type=template&id=48dd11d5&"
import script from "./proceed-abandoned-case.vue?vue&type=script&lang=js&"
export * from "./proceed-abandoned-case.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports